const REDACTED = '***';

const URI_CREDENTIALS = /([a-z][a-z0-9+.-]*:\/\/)[^/\s:@]+(?::[^@\s/]*)?@/gi;
const KEY_VALUE_SECRET =
  /\b(password|passwd|pwd|token|secret|api[_-]?key|access[_-]?key)(\s*[=:]\s*)("[^"]*"|'[^']*'|[^\s;,&]+)/gi;

/**
 * Elimina secretos de un mensaje de diagnostico antes de exponerlo: valores de secretos
 * resueltos, credenciales embebidas en URIs y pares `password=...` de cadenas de conexion.
 *
 * @example sanitizeMessage('fallo en postgres://bi:s3cr3t@db/erp', []) // 'fallo en postgres://***@db/erp'
 */
export function sanitizeMessage(message: string, secrets: readonly string[] = []): string {
  let sanitized = message;
  for (const secret of secrets) {
    if (secret.length >= 3) sanitized = sanitized.split(secret).join(REDACTED);
  }
  return sanitized
    .replace(URI_CREDENTIALS, `$1${REDACTED}@`)
    .replace(KEY_VALUE_SECRET, `$1$2${REDACTED}`);
}
